import { render, staticRenderFns } from "./UpcomeDrawer.vue?vue&type=template&id=afc8beaa&scoped=true"
import script from "./UpcomeDrawer.vue?vue&type=script&lang=js"
export * from "./UpcomeDrawer.vue?vue&type=script&lang=js"
import style0 from "./UpcomeDrawer.vue?vue&type=style&index=0&id=afc8beaa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc8beaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afc8beaa')) {
      api.createRecord('afc8beaa', component.options)
    } else {
      api.reload('afc8beaa', component.options)
    }
    module.hot.accept("./UpcomeDrawer.vue?vue&type=template&id=afc8beaa&scoped=true", function () {
      api.rerender('afc8beaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/loyout/components/UpcomeDrawer.vue"
export default component.exports